<template>
  <div class="gamepass-instruction transfer__wrapper">
    <form-layout
      :main-title="$t('transfer.title')"
      :mobile-title="$t('transfer.titleMobile')"
      :title="pageTitle"
      :sub-title="pageSubTitle"
      :submit-text="submitBtnText"
      title-class="transfer-instruction-gamepass__title"
      @back="goToPlace"
      @submit="toggleGamepass"
    >
      <div class="transfer-instruction-gamepass">
        <Loader v-if="loading" />

        <div class="transfer-instruction-gamepass__count">
          <p>{{ $t('transfer.gamepass.setPrice') }}</p>
          <small>{{ totalRobux.toLocaleString('ru-RU') }} R$</small>
        </div>
        <div class="transfer-instruction-gamepass__instruction-video-wrapper">
          <template v-if="step === 'edit'">
            <div class="totalRobux">{{ totalRobux.toLocaleString('ru-RU') }}</div>
            <!--            <div class="totalRobuxFromUser">{{ totalRobuxFromUser.toLocaleString('ru-RU') }}</div>-->
          </template>
          <img
            class="transfer-instruction-gamepass__instruction-video"
            :src="currentInstructionVideo"
            alt="instruction"
          />
        </div>
      </div>
    </form-layout>
  </div>
</template>

<script>
import './transferInstructionGamepass.scss'

import Loader from '@/components/LoaderBar/LoaderBar.vue'
import FormLayout from '@/components/Base/FormLayout/FormLayout.vue'

import windowSize from '@/mixins/windowSize'

export default {
  name: 'TransferInstructionGamepass',
  props: ['data'],
  mixins: [windowSize],
  components: {
    FormLayout,
    Loader
  },
  data() {
    return {
      step: 'create',
      isCreated: false,
      isEdited: false,
      loading: true,
      hint: false,
      hintGamepassError: false,
      gamepassId: null
    }
  },
  created() {
    this.loading = true
    if (this.$store.state.isScipGamepass) {
      this.$emit('changeModal', {
        modal: 'TransferPrivatPlace'
      })
      return
    }

    this.getGamepasses().then(data => {
      this.loading = false

      if (data.data.length) {
        const gamepassItem = data.data[0]
        this.step = 'edit'
        this.gamepassId = data.data[0].id

        // Останавливаем покупку, если у пользователя включено региональное ценообразование
        if (this.validateRegionalPrice(gamepassItem)) return

        if (gamepassItem?.price === this.totalRobux) {
          this.showSuccessHint()
          this.$store.commit('setScipGamepass', true)
          this.$analytics.send('purch_trans_4_gamepass', {})

          // Проверка баланса перед переходом
          const balance = this.$store.getters.balance
          const requiredAmount = this.$store.state.paymentsOrder.amount

          if (balance < requiredAmount) {
            // Очищаем флаг SuperPass в store для обычного Transfer
            this.$store.commit('paymentsOrder/setSuperPassData', {
              isSuperPass: false,
              superPassId: ''
            })

            // Если денег не хватает - открываем форму выбора способа оплаты
            this.$emit('changeModal', {
              modal: 'TransferPaymentMethod'
            })
            return
          }

          // Если баланса достаточно - идем на оплату
          this.$emit('changeModal', {
            modal: 'OrderConfirmation'
          })
        }
      } else this.step = 'create'
    })
  },
  methods: {
    goToPlace() {
      this.$emit('changeModal', {
        modal: 'TransferPrivatPlace'
      })
    },
    getGamepasses() {
      return fetch(`https://transfer.backend-pier.com/get_passes/${this.data.uid}?robux_amount=${this.totalRobux}`)
        .then(res => res.json())
        .catch(err => console.log(err))
    },
    createGamepass() {
      this.isCreated = true
    },
    editGamepass() {
      this.isEdited = true
    },
    toggleGamepass() {
      if (this.step === 'create') {
        if (!this.isCreated) {
          this.createGamepass()
          window.open(
            `https://create.roblox.com/dashboard/creations/experiences/${this.data.uid}/passes/create`,
            '_blank'
          )
          return
        }
        this.submit()
      } else {
        if (!this.isEdited) {
          this.editGamepass()
          window.open(
            `https://create.roblox.com/dashboard/creations/experiences/${this.data.uid}/passes/${this.gamepassId}/sales`,
            '_blank'
          )
          return
        }
        this.submit()
      }
    },
    showHint(ganepassError = true) {
      this.isCreated = false
      this.isEdited = false
      this.hintGamepassError = ganepassError

      const description = this.hintGamepassError
        ? this.$t('transfer.gamepass.checkData')
        : this.$t('transfer.gamepass.serverError')

      this.$store.dispatch('notification/setNotification', {
        title: this.$t('general.warning'),
        description,
        type: 'error'
      })
    },
    validateRegionalPrice(gamepassItem) {
      const regionalPrice = gamepassItem.regional_price

      if (regionalPrice) {
        this.$store.dispatch('notification/setNotification', {
          title: this.$t('general.warning'),
          description: this.$t('transfer.gamepass.regionalPriceHint'),
          type: 'error'
        })
      }
      return regionalPrice
    },
    submit() {
      this.loading = true

      this.getGamepasses().then(data => {
        this.loading = false
        // Проверка на серверную ошибку
        if (!data?.data?.length) {
          this.showHint(false)
          return
        }

        if (!this.isEdited) {
          if (data.data.length) {
            this.gamepassId = data.data[0]?.id
            this.step = 'edit'
            return
          }

          this.showHint()
          return
        }
        // Останавливаем покупку, если у пользователя включено региональное ценообразование
        if (this.validateRegionalPrice(data.data[0])) return

        if (data.data.length && data.data[0].price === this.totalRobux) {
          this.gamepassId = data.data[0].id
          this.$analytics.send('purch_trans_4_gamepass', {})

          // Проверка баланса перед переходом
          const balance = this.$store.getters.balance
          const requiredAmount = this.$store.state.paymentsOrder.amount

          if (balance < requiredAmount) {
            // Очищаем флаг SuperPass в store для обычного Transfer
            this.$store.commit('paymentsOrder/setSuperPassData', {
              isSuperPass: false,
              superPassId: ''
            })

            // Если денег не хватает - открываем форму выбора способа оплаты
            this.$emit('changeModal', {
              modal: 'TransferPaymentMethod'
            })
            return
          }

          // Если баланса достаточно - идем на оплату
          this.$emit('changeModal', {
            modal: 'OrderConfirmation'
          })
        } else this.showHint()
      })
    },
    showSuccessHint() {
      this.$store.dispatch('notification/setNotification', {
        title: this.$t('general.success'),
        description: this.$t('transfer.gamepass.successHint'),
        type: 'success'
      })
    }
  },
  computed: {
    totalRobuxFromUser() {
      return this.data.bonusForGamepass
        ? Number(this.data.totalRobux) + Number(this.data.bonusForGamepass)
        : this.data.totalRobux
    },
    totalRobux() {
      return Math.round(this.totalRobuxFromUser / 0.7)
    },
    pageTitle() {
      const title =
        this.step === 'create' ? this.$t('transfer.gamepass.creating') : this.$t('transfer.gamepass.settingUp')
      return !this.loading ? title + ' GAME PASS' : ''
    },
    pageSubTitle() {
      const subtitle =
        this.step === 'create'
          ? this.$t('transfer.gamepass.createGamepass')
          : this.$t('transfer.gamepass.checkInstructionNew')
      return !this.loading ? subtitle : ''
    },
    submitBtnText() {
      const create = !this.isCreated ? this.$t('actions.create') : this.$t('actions.ready')
      const edit = !this.isEdited ? this.$t('actions.edit') : this.$t('actions.ready')
      return this.step === 'create' ? create : edit
    },
    submitBtnLeftIcon() {
      const create = this.isCreated && '/transfer/checkmark.svg'
      const edit = this.isEdited && '/transfer/checkmark.svg'
      return this.step === 'create' ? create : edit
    },
    submitBtnRightIcon() {
      const create = !this.isCreated && '/transfer/arrow-right.svg'
      const edit = !this.isEdited && '/transfer/arrow-right.svg'
      return this.step === 'create' ? create : edit
    },
    currentInstructionVideo() {
      const isMobile = this.screenWidth < 743
      const create = isMobile
        ? require('@/assets/gif/Pier_pass_create_mobile_3.gif')
        : require('@/assets/gif/Pier_pass_create_desktop_2.gif')
      const edit = isMobile
        ? require('@/assets/gif/Pier_pass_config_mobile_transparent_3.gif')
        : require('@/assets/gif/Pier_pass_config_desktop_transparent_2.gif')
      return this.step === 'create' ? create : edit
    }
  }
}
</script>
